import React, { useState } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { logger } from '@fiverr-private/obs';
import { LazyComponent } from '@fiverr-private/ui_utils';
import { ProjectManagementL2Icon } from '@fiverr-private/visuals';
import { IPrimaryBasicData, IPrimaryCommonProps } from '@fiverr-private/primary_section_sdk';
import { borderColor } from './ProjectManagementCard.ve.css';

const lazyImport = () =>
    import(/* webpackChunkName: 'ProjectManagementModal' */ '../ProjectManagementModal/ProjectManagementModal');
const onImportError = (error) => logger.error(error, { description: 'Failed to lazy load ProjectManagementModal' });

const PRIMARY_PROJECT_MANAGEMENT = 'primary_project_management';

export const ProjectManagerCard = ({ reportClick }: IPrimaryBasicData & IPrimaryCommonProps) => {
    const [isProjectManagementModalOpened, setIsProjectManagementModalOpened] = useState(false);
    const handleOpenProjectManagementModal = () => {
        setIsProjectManagementModalOpened(true);
        reportClick({});
    };

    return (
        <Stack
            position="relative"
            padding="6"
            borderRadius="lg"
            borderWidth="sm"
            borderColor="grey_400"
            direction="column"
            gap="0"
            height="100%"
        >
            <ProjectManagementL2Icon size="sm" />
            <Stack marginTop="4" gap="1" direction="column">
                <Heading as="h4" marginBottom="1">
                    <I18n k={`${PRIMARY_PROJECT_MANAGEMENT}.title`} />
                </Heading>
                <Text>
                    <I18n k={`${PRIMARY_PROJECT_MANAGEMENT}.description`} />
                </Text>
            </Stack>
            <Stack justifyContent="flexStart" marginTop="auto">
                <Button variant="outline" className={borderColor} onClick={handleOpenProjectManagementModal}>
                    <I18n k={`${PRIMARY_PROJECT_MANAGEMENT}.link_title`} />
                </Button>
            </Stack>
            <LazyComponent
                lazyImport={lazyImport}
                shouldImport={isProjectManagementModalOpened}
                componentProps={{
                    isOpen: isProjectManagementModalOpened,
                    onClose: () => setIsProjectManagementModalOpened(false),
                    reportClick,
                }}
                onError={onImportError}
            />
        </Stack>
    );
};
